import React from 'react'
import {Form} from 'antd'

import BButton from 'components/Form/Fields/BButton'

const FormHandler = ({submitCallback, submitTitle, initialValues, children, className}) => {
  const [loading, setLoading] = React.useState(false)
  const [form] = Form.useForm()

  const onFinish = values => {
    setLoading(true)
    submitCallback(values, setLoading)
  }

  return (
    <Form form={form} onFinish={onFinish} initialValues={initialValues} className={className}>
      {children}

      <BButton type='primary' htmltype='submit' loading={loading}>
        {submitTitle ? submitTitle : 'Submit'}
      </BButton>
    </Form>
  )
}

export default FormHandler
